import { createStore } from 'vuex';
import routes from './routes';
import users from './user';
import models from './model';
import materials from './material';
import textureFiles from './textureFile';
import ci from './ci';

const store = createStore({
  modules: { routes, users, models, materials, textureFiles, ci },
});

export default store;
